// extracted by mini-css-extract-plugin
export var layoutBlog = "styles-module--layoutBlog--75f91";